import { SvgIconProps } from '@mui/material';

const ZizziPoint = ({ width = '60', height = '60', className }: SvgIconProps) => (
  <svg width={width} height={height} viewBox="0 0 60 60" fill="none" className={className}>
    <g filter="url(#filter0_d_10668_312062)">
      <path
        d="M9.58879 38.306C5.44059 31.4948 4.7116 23.8868 8.33299 16.4474C9.31022 14.438 10.5795 13.0636 12.1083 11.4484C13.9527 9.50205 15.5499 7.93049 17.8852 6.63632C23.1926 3.6938 31.1677 3.56885 36.2449 4.55122C63.3491 9.79435 58.0788 57.7104 29.5536 51.4345C24.2743 50.2733 20.3889 47.8133 15.8577 44.8479C13.136 43.0608 11.2782 41.0789 9.58879 38.306Z"
        fill="#D67347"
      />
    </g>
    <g filter="url(#filter1_d_10668_312062)">
      <path
        d="M24.8957 33.3121C26.2416 33.1335 27.4854 33.2391 28.7085 33.1632C29.2786 33.1365 29.85 33.1679 30.4138 33.257C30.683 33.2912 31.0054 33.3701 31.2302 33.2957C31.5511 33.19 31.9845 32.2837 31.8218 31.9474C30.0248 30.7911 27.9927 30.0663 25.9221 29.5544C25.4784 29.4458 25.0747 29.4249 24.5467 29.3282C24.0435 29.2595 23.5369 29.2183 23.0293 29.2047C22.8734 29.2133 22.7178 29.1826 22.5767 29.1154C22.38 28.9666 22.5516 28.7374 22.6699 28.5618C23.4656 27.3935 24.0468 26.1658 24.8336 25.0779C25.5021 24.1538 26.3658 23.0525 26.8598 22.0703C27.4514 20.9006 28.1155 20.0508 28.8313 19.0939C29.17 18.6475 29.59 18.1326 29.7837 17.7903C30.1521 17.1326 30.572 16.5056 31.0394 15.9152C31.3056 15.5788 31.6739 15.3199 31.6827 14.8452C31.1562 14.4181 30.5469 13.5058 29.8296 13.7067C28.68 13.9718 27.4961 14.0527 26.3215 13.9463C26.0464 13.927 25.7668 13.8511 25.4932 13.8124C25.2196 13.7737 24.9505 13.7156 24.6828 13.6635C24.0572 13.5251 23.3251 13.415 22.6758 13.2558C21.4704 12.9581 20.1615 12.9581 18.9236 13.0653C17.6857 13.1724 15.6359 13.924 15.2513 15.1294C15.0739 15.6875 14.6479 16.2694 14.9067 16.9346C16.3012 17.0875 17.7028 17.164 19.1055 17.1638C20.3523 17.2605 21.463 16.9926 22.7335 17.2486C23.1934 17.3423 24.0217 17.1697 24.4609 17.4316C23.5587 18.7157 22.588 19.9497 21.5532 21.1283C20.8955 21.8661 20.2971 22.6553 19.7637 23.4886C19.225 24.2913 18.6184 25.0456 17.9505 25.7432C16.5306 27.3668 14.8786 29.4785 14.432 30.0812C13.9558 30.7256 13.268 31.5367 13.0506 32.1126C12.8805 32.559 13.1601 33.1692 13.5757 33.3775C13.7664 33.7109 14.0889 33.9341 14.3699 34.1782C15.4377 34.7422 16.5114 34.7735 17.6502 34.574C17.9312 34.5254 18.2137 34.4758 18.4977 34.4252C20.1911 34.0978 21.9674 33.9148 23.5868 33.4951C24.0192 33.4092 24.4563 33.3496 24.8957 33.3165"
        fill="white"
      />
      <path
        d="M41.0394 41.0274C42.3851 40.8489 43.6287 40.9545 44.8516 40.8786C45.4216 40.8519 45.9929 40.8833 46.5566 40.9723C46.8257 41.0066 47.1481 41.0854 47.3729 41.011C47.6937 40.9054 48.127 39.9994 47.9644 39.6632C46.1677 38.5073 44.1359 37.7828 42.0657 37.271C41.622 37.1624 41.2183 37.1416 40.6904 37.0449C40.1873 36.9762 39.6808 36.935 39.1732 36.9214C39.0174 36.9298 38.8619 36.8991 38.7207 36.8321C38.5241 36.6834 38.6956 36.4543 38.8139 36.2787C39.6095 35.1109 40.1906 33.8836 40.9773 32.7961C41.6457 31.8722 42.5093 30.7713 43.0032 29.7895C43.5947 28.6202 44.2586 27.7707 44.9743 26.8141C45.313 26.3678 45.7329 25.8531 45.9267 25.5109C46.2954 24.8535 46.7157 24.2266 47.1836 23.6365C47.4498 23.3002 47.818 23.0414 47.8283 22.5668C47.3004 22.1399 46.6912 21.2279 45.974 21.4287C44.8246 21.6938 43.6408 21.7747 42.4664 21.6683C42.1913 21.6489 41.9133 21.573 41.6383 21.5344C41.3632 21.4957 41.0956 21.4377 40.8279 21.3782C40.2024 21.2398 39.4705 21.1297 38.8213 20.9705C37.6161 20.673 36.3074 20.673 35.0697 20.7801C33.832 20.8872 31.778 21.6489 31.3936 22.851C31.2161 23.4088 30.7902 23.9905 31.049 24.6555C32.4432 24.8084 33.8447 24.8849 35.2472 24.8846C36.4937 24.9813 37.6043 24.7135 38.8745 24.9694C39.3344 25.0631 40.1625 24.8906 40.6017 25.1524C39.6996 26.436 38.7291 27.6696 37.6945 28.8478C37.0368 29.5853 36.4385 30.3743 35.9052 31.2072C35.3666 32.0097 34.7601 32.7638 34.0923 33.4611C32.6742 35.0841 31.0209 37.1951 30.5743 37.7976C30.0982 38.4418 29.412 39.2526 29.1932 39.8283C29.0231 40.2746 29.3026 40.8846 29.7181 41.0928C29.9089 41.4261 30.2313 41.6492 30.5122 41.8932C31.5799 42.457 32.6535 42.4883 33.7921 42.2889C34.073 42.2403 34.3555 42.1907 34.6394 42.1402C36.3326 41.8129 38.1085 41.6299 39.7278 41.2104C40.16 41.1245 40.5971 41.0649 41.0364 41.0318"
        fill="white"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_10668_312062"
        x="0"
        y="0"
        width="60"
        height="60"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="2" />
        <feGaussianBlur stdDeviation="3" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10668_312062" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10668_312062"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_10668_312062"
        x="13"
        y="13"
        width="35"
        height="30.4004"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.675 0 0 0 0 0.248046 0 0 0 0 0.106875 0 0 0 1 0"
        />
        <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_10668_312062" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_10668_312062"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
);

export default ZizziPoint;
